import React from 'react';
import { Screen } from '../design/primitives';
import HealthGoals from '../components/HealthGoals';

const HealthGoalsPage: React.FC = () => {
  return (
    <Screen>
      <HealthGoals />
    </Screen>
  );
};

export default HealthGoalsPage;
